import React, { useEffect, useState } from 'react';
import { businessAPI } from '../../api/businesses';
import BusinessCard from '../dashboard/BusinessCard';

const Favorites = () => {
  const [loading, setLoading] = useState(true);
  const [businesses, setBusinesses] = useState([]);

  const loadFavorites = async () => {
    setLoading(true);
    try {
      const res = await businessAPI.getFavorites();
      const list = res?.data?.data?.businesses || [];
      setBusinesses(Array.isArray(list) ? list : []);
    } catch (e) {
      setBusinesses([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadFavorites();
  }, []);

  const handleFavoriteChanged = (businessId, nextIsFavorite) => {
    if (nextIsFavorite) return;
    setBusinesses((prev) => prev.filter((b) => String(b.id) !== String(businessId)));
  };

  if (loading) return <div className="text-center py-8">Loading...</div>;

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold">Favorites</h1>
        <p className="text-sm text-gray-600 mt-1">Your saved businesses</p>
      </div>

      {businesses.length === 0 ? (
        <div className="text-center py-12 bg-white rounded-lg shadow-md">
          <p className="text-gray-500">No favorite businesses yet.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {businesses.map((b) => (
            <BusinessCard
              key={b.id}
              business={b}
              onFavoriteChanged={handleFavoriteChanged}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Favorites;

